import { HistoricalPercentageChangeConfig } from 'widgets/historicalPercentageChange/store/HistoricalPercentageChangeConfig.ts';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater.ts';
import { CapsuleSettingsSymbolEditor } from 'widgets/tiles/components/tile/CapsuleSettingsSymbolEditor.tsx';
import WidgetNewportAppSettingsEditor from 'widgets/WidgetSettingsEditing/WidgetNewportAppSettingsEditor.tsx';
import React from 'react';
import { useHistoricalPercentageChangeCapsuleConfigSlice } from 'widgets/historicalPercentageChange/capsule/store.ts';
import WidgetSettingsNumericValueEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsNumericValueEditor.tsx';
import WidgetSettingsCheckboxValueEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsCheckboxValueEditor.tsx';
export const HistoricalPercentageChangeCapsuleSettingsText = `Historical % Change Capsule Settings`;

export function HistoricalPercentageChangeCapsuleSettings({
    config: propsConfig,
    onChange,
}: {
    config?: HistoricalPercentageChangeConfig;
    onChange?: (nextDelta: Partial<HistoricalPercentageChangeConfig>) => void;
}) {
    const { config: configSliceConfig, dispatchConfigChanged } =
        useHistoricalPercentageChangeCapsuleConfigSlice();

    const { debouncedApplyWidgetConfigChange } = useWidgetConfigUpdater(
        dispatchConfigChanged,
        onChange
    );
    const config = propsConfig ?? configSliceConfig;

    return (
        <div className="HistoricalPercentageChangeCapsuleSettings">
            <div className="group ">
                <CapsuleSettingsSymbolEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />

                <WidgetSettingsNumericValueEditor
                    propertyName={'periodQty'}
                    config={config}
                    label="Trading Days"
                    min={1}
                    onChange={debouncedApplyWidgetConfigChange}
                />

                <WidgetSettingsCheckboxValueEditor
                    propertyName={'hidePrice'}
                    config={config}
                    label="Hide Price Series"
                    onChange={dispatchConfigChanged}
                />

                <WidgetSettingsCheckboxValueEditor
                    propertyName={'hideVolume'}
                    config={config}
                    label="Hide Volume Series"
                    onChange={dispatchConfigChanged}
                />

                <WidgetSettingsCheckboxValueEditor
                    propertyName={'hideAverageVolume'}
                    config={config}
                    label="Hide Average Volume"
                    onChange={dispatchConfigChanged}
                />
            </div>

            <WidgetNewportAppSettingsEditor />
        </div>
    );
}
